import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { HeaderModal } from './types';

const initialState: {
  betLimitsOpen: boolean;
  openedModal: HeaderModal | null;
  selectedHelpPage: string | null;
  isMiniLobbyOpen: boolean;
  isBackToGameHidden: boolean;
  navExpanded: boolean;
  navForcedExpanded: boolean;
  quickGuideIsShown: boolean;
  navRoute: string[];
} = {
  betLimitsOpen: false,
  openedModal: null,
  selectedHelpPage: null,
  isMiniLobbyOpen: false,
  isBackToGameHidden: false,
  navExpanded: false,
  navForcedExpanded: false,
  quickGuideIsShown: false,
  navRoute: [],
};

export const headerSlice = createSlice({
  name: 'header',
  initialState,
  reducers: {
    setBetLimitsOpen: (state, action: PayloadAction<boolean>) => {
      state.betLimitsOpen = action.payload;
    },
    setOpenedModal: (state, action: PayloadAction<HeaderModal | null>) => {
      state.openedModal = action.payload;
    },
    setSelectedHelpPage: (state, action: PayloadAction<string | null>) => {
      state.selectedHelpPage = action.payload;
    },
    setMiniLobbyOpen: (state, action: PayloadAction<boolean>) => {
      state.isMiniLobbyOpen = action.payload;
      if (!action.payload) {
        state.isBackToGameHidden = false;
      }
    },
    setBackToGameHidden: (state, action: PayloadAction<boolean>) => {
      state.isBackToGameHidden = action.payload;
    },
    setNavExpanded: (state, action: PayloadAction<boolean>) => {
      if (state.navForcedExpanded) return;
      state.navExpanded = action.payload;
    },
    setNavForcedExpanded: (state, action: PayloadAction<boolean>) => {
      state.navForcedExpanded = action.payload;
      if (action.payload) state.navExpanded = true;
    },
    pushNavRoute: (state, action: PayloadAction<string>) => {
      state.navRoute.push(action.payload);
    },
    setQuickGuideShown: (state) => {
      state.quickGuideIsShown = true;
    },
    popNavRoute: (state) => {
      state.navRoute.pop();
      if (state.navRoute.length === 0) {
        state.navExpanded = false;
        state.navForcedExpanded = false;
      }
    },
    replaceNavRoute: (state, action: PayloadAction<string>) => {
      state.navRoute[state.navRoute.length - 1] = action.payload;
    },
    setNavRoute: (state, action: PayloadAction<string[]>) => {
      state.navRoute = action.payload;
      if (state.navRoute.length === 0) {
        state.navExpanded = false;
        state.navForcedExpanded = false;
      }
    },
  },
});

export const headerActions = headerSlice.actions;
